import { getIncidentCardDetailsInfoResponseType } from '@/modules/adjusterReportModules/IncidentDetails/queries/incidentDetails/property/getIncidentCardDetailsInfoProperty.types';
import { DetailCardItemData } from '@/common/components/DetailCard/DetailCard.types.ts';
import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi.ts';

export const incidentDetailsCardPropertyDataGenerator = (
  data: getIncidentCardDetailsInfoResponseType,
): DetailCardItemData[] => [
  {
    type: 'default',
    keyName: 'استان - شهر',
    value: `${data.visit_county.name}, ${data.visit_province.name}`,
    hasBullet: true,
  },
  {
    type: 'default',
    keyName: 'تاریخ تشکیل:',
    value: convertTimestampToShamsi(data.creation_date),
    hasBullet: true,
  },
  {
    type: 'default',
    keyName: 'بیمه‌گر (مقصر)',
    value: data.insurance.fa_const,
    hasBullet: true,
  },
  // {
  //   type: 'default',
  //   keyName: 'ارسال شده از',
  //   value: 'بکند نمیده',
  //   hasBullet: true,
  // },
  {
    type: 'default',
    keyName: 'علت حادثه',
    value: data?.event_cause?.name,
    hasBullet: true,
  },
  {
    type: 'default',
    keyName: 'تاریخ وقوع حادثه',
    value:
      data?.event_happening_date &&
      convertTimestampToShamsi(+data?.event_happening_date),
    hasBullet: true,
  },
  {
    type: 'default',
    keyName: 'ساعت وقوع حادثه',
    value: data?.event_happening_time,
    hasBullet: true,
  },
  {
    type: 'default',
    keyName: 'محل وقوع حادثه',
    value: data.event_happening_site,
    hasBullet: true,
  },
];
